export interface CalendarPickerDateRange {
  startDate?: Date;
  endDate?: Date;
}

export type CalendarPickerSetter<T> =
  | React.Dispatch<React.SetStateAction<T>>
  | ((value: T) => void);

export enum CalendarPickerNavigationAction {
  Previous = -1,
  Next = 1,
}

export type CalendarPickerDefinedRange = {
  startDate: Date;
  endDate: Date;
  label: string;
};
